<!-- 马良笔双师课堂课表组件 -->
<template>
  <div :class="isMobile ? 'mobile' : 'pc'">
    <div class="lw-schedule">
      <div class="lw-schedule-center">
        <div class="lw-schedule-center-top">
          <div class="lw-schedule-center-top-title">
          </div>
          <div class="lw-schedule-center-top-operation">

            <class-id-code-join
              :garden-id="currentGardenId"
              :token="token"
              :user-type="userType"
              @joinClassroom="classIdCodeJoinClassroom"
            >
              <i class="iconfont lwicon-hudongbaiban-icon256"/> 加入
            </class-id-code-join>
          </div>
        </div>

          <div class="lw-schedule-center-body">
            <div class="lw-schedule-center-body-title">
              <span>创建马良笔双师课堂</span>
            </div>
            <div class="lw-schedule-center-body-content">
              <el-form ref="createForm"
                      :label-position="labelPosition"
                      :model="dialogForm"
                      :rules="dialogFormRules"
                      @submit.native.prevent
              >
                <el-form-item label="课堂名称：" prop="classroomName">
                  <el-input v-model="dialogForm.classroomName" placeholder="50个字符以内，必填" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="课堂ID码：" prop="classIdCode">
                  <el-input v-model="dialogForm.classIdCode" placeholder="6位数字或字母，必填。" maxlength="6"></el-input>
                </el-form-item>

              </el-form>

              <p class="lw-schedule-center-body-content-error">{{ createDialogErrorMessage }}</p>

              <div class="lw-schedule-center-body-content-button">
                <el-button v-prevent-db-click type="primary" @click="createFromSubmit" :disabled="createButtonDisable">
                  创建
                </el-button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {UserType} from '@/ts/Enum';
import RTCClient from "@/rtc/RTCClient";

export default {
  name: "schedule",
  data() {
    return {
      rtcActivityBaseInfo: null, // rtc活动的基础信息
      teacherInfo: null, // 当前登录的教师用户信息
      token: '', // 当前用户的认证token
      currentGardenId: "", // 当前选中的园区
      // 加入课堂弹框内表单的对其方式
      labelPosition: 'right',
      // 创建马良笔双师课堂弹框内的表单
      dialogForm: {
        classId: '0',
        classroomName: '',
        classIdCode: ''
      },
      dialogFormRules: {
        classroomName: [
          {required: true, message: '请输入课堂名称', trigger: 'blur'}
        ],
        classIdCode: [
          {required: true, message: '请输入课堂ID码', trigger: 'blur'},
          {pattern: /^[0-9A-Za-z]{6}$/, message: '课堂ID码必须是六位数字或者字母', trigger: 'blur'}
        ]
      },
      // 创建弹框中的错误提示文案
      createDialogErrorMessage: '',
      // 创建弹框中的创建按钮是否可用
      createButtonDisable: true,
      // 当前客户端是否支持rtc，默认为false
      currentClientSupportRtc: false,
      // 当前用户在rtc中的的身份
      userType: UserType.teacher,
    };
  },
  mounted() {
    const userInfo = this.local$.getItem('userInfo')
    if (userInfo) {
      this.teacherInfo = JSON.parse(userInfo)
    }
    this.token = window.localStorage.getItem('LWToken')
    this.currentGardenId = this.local$.getItem('gardenId')
    this.checkRtcSupport().then(() => {
      this.initRtcBaseInfo()
    })
  },
  watch: {
    // 创建马良笔双师课堂表单
    dialogForm: {
      handler() {
        this.createDialogErrorMessage = ''
        this.createDialogFormValidate()
      },
      deep: true
    }
  },
  methods: {

    //---------------------------------  发起马良笔双师课堂弹框相关函数 begin  ---------------------------------------------

    /**
     * 校验浏览器是否支持rtc
     *
     * <p>
     *   拿到是否支持的结果后，销毁当前页面内的RtcClient实例
     * </p>
     */
    checkRtcSupport() {
      return new Promise((resolve) => {
        RTCClient.instance.isSupport().then(res => {
          const {isSupported} = res
          // 如果不支持，给出提示弹框
          this.currentClientSupportRtc = isSupported
          RTCClient.instance.dispose()
          resolve()
        }, err => {
          this.currentClientSupportRtc = false
          RTCClient.instance.dispose()
          resolve()
        }).catch(err => {
          this.currentClientSupportRtc = false
          RTCClient.instance.dispose()
          resolve()
        })
      })

    },

    /**
     * 创建按钮点击事件
     *
     * <p>
     *   先校验当前客户端所在浏览器是否支持rtc，如果不支持，则
     *   填充活动基本信息，并且调用打开弹框的函数
     * </p>
     */
    initRtcBaseInfo() {
      if (!this.currentClientSupportRtc) {
        this.showRtcNotSupportConfirm()
        return
      }
      let gardenName = ''
      if (this.teacherInfo.gardens && this.teacherInfo.gardens[0]) {
        gardenName = this.teacherInfo.gardens[0].gardenName
      }
      this.rtcActivityBaseInfo = {
        id: '',
        date: '',
        classRoomId: 0,
        week: '',
        fullYear: '',
        prepare_status: '',
        garden_id: this.currentGardenId,
        garden_name: gardenName,
        grade_id: '',
        grade_name: '',
        class_id: '',
        class_name: '',
        class_section: '',
        subject_name: '',
        subject_code: '',
        activity_teacher_name: this.teacherInfo.displayName,
        activity_teacher_id: this.teacherInfo.accountId
      }
    },

    /**
     * 展示当前浏览器不支持rtc时的确认弹框
     */
    showRtcNotSupportConfirm() {
      let confirmTitle =
        '<div style="font-size: 16px;text-indent:2em;line-height: 30px">您当前使用的浏览器类型或版本不支持发起音视频双向通信。请更换至以下浏览器类型或版本后再试：\n' +
        'Chrome浏览器72或以上版本，Edge浏览器80或以上版本</div>';

      this.$elementConfirm(confirmTitle, "提示", {
        confirmButtonText: "确定",
        customClass: this.isMobile ? 'mobile-confirm-box' : '',
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        // type: 'warning'
      }).then(() => {
      })
    },

    /**
     * 表单校验函数
     */
    createDialogFormValidate() {
      // 如果两个输入框的内容不全，直接禁用
      if (!this.dialogForm.classroomName || !this.dialogForm.classIdCode) {
        this.createButtonDisable = true
        return
      }
      this.$refs['createForm'].validate((valid) => {
        this.createButtonDisable = !valid
      })
    },

    /**
     * 创建表单提交事件
     *
     * 获取rtc的直播用户信息，获取成功后再进入直播间
     */
    createFromSubmit() {
      this.$refs['createForm'].validate((valid) => {
        if (valid) {
          this.rtcActivityBaseInfo.activity_name = this.dialogForm.classroomName

          RTCClient.instance.getAuthInfo(
            this.token,
            this.dialogForm.classIdCode,
            'CA',
            UserType.teacher,
            this.rtcActivityBaseInfo.garden_id
          ).then(authInfo => {
            let {...params} = this.rtcActivityBaseInfo
            params.rtc_auth_info = authInfo
            params.class_id_code = this.dialogForm.classIdCode
            params.user_type = UserType.teacher.toString()
            params.user_id = this.teacherInfo.accountId
            params.display_name = this.teacherInfo.displayName
            this.$router.push({
              name: this.isMobile?'FreeCreateDetailMobile':"TeacherClassroom",
              params: params
            });
          }).catch(err => {
            switch (err.Code) {
              case 700:
              case 702:
              case 703:
                //  701:云端未知异常
                //  702:云端获取园区对应的rtc AppID和appkey 报错
                //  703:云端获取当前频道ID的可用性时报错
                this.createDialogErrorMessage = err.Message.UserMsg
                break
              case 701:
                this.$message.error('您当前的音视频通信认证令牌已超过最大允许时长。系统将自动结束当前课堂。')
                this.local$.clearLocal()
                this.cookie$.removeCookie("LWToken")
                //  用户的优课场域认证token时效，回到登录页面
                window.open(this.filePre$.loginUrl + "/logout", "_self")
                break
              case 704:
                //  当前请求的频道ID不可用
                this.createDialogErrorMessage = '当前课堂ID码在当前时段已被占用，请更改课堂ID码或稍后再试。'
                break
              default:
                this.createDialogErrorMessage = err.Message.UserMsg
                break
            }
          })
        }
      })
    },

    //---------------------------------  发起马良笔双师课堂弹框相关函数 end  ---------------------------------------------

    /**
     * 通过课堂ID码加入课堂
     */
    classIdCodeJoinClassroom(classIdCode, authInfo) {
      this.$router.push({
        name: this.isMobile?'StudentClassroomMobile':'StudentClassroom',
        params: {
          class_id_code: classIdCode,
          rtc_auth_info: authInfo,
          user_id: this.teacherInfo.accountId,
          user_type: this.userType,
          display_name: this.teacherInfo.displayName
        }
      })
    }
  }
};


</script>

<style scoped lang="scss">
@import "../../assets/scss/index";
.pc {
  .lw-schedule {

    &-center {
      &-top {
        padding-top: computer(20px);
        display: flex;
        align-items: flex-start;

        &-title {
          width: 80%;
          font-size: computer(16px);
          font-weight: bold;
          height: computer(40px);
          line-height: computer(40px);
        }

        &-operation {
          display: flex;
          justify-content: flex-end;
          width: 20%;

          ::v-deep {
            .class-id-code-join-entry {
              .dialog-button {
                min-width: computer(100px);
                font-size: computer(16px);
                padding: computer(6px) computer(20px);

                > span {
                  display: flex;
                  align-items: center;
                }

                .iconfont {
                  font-size: computer(24px);
                  margin-right: computer(5px);
                }

                .lwicon-hudongtiyansheji:before {
                  font-size: computer(26px);
                }
              }

              .el-button--primary {
                background: $color_main;
              }
            }

          }

        }
      }


      &-body {
        width: calc(100% - #{computer(40px)});
        padding: computer(20px) computer(20px) 0;

        &-title {
          margin-top: computer(20px);
          text-align: center;

          span {
            height: computer(30px);
            line-height: computer(30px);
            font-size: computer(24px);
            font-weight: 700;
          }
        }

        &-content {
          width: calc(100% - #{computer(30px)});
          margin: computer(60px) computer(15px) 0;

          ::v-deep .el-form {
            width: computer(550px);
            margin: 0 auto;

            .el-form-item {
              margin: 0 computer(40px) computer(40px) computer(-40px);

              .el-form-item__label {
                width: computer(120px);
                padding: 0;
              }

              .el-form-item__content {
                width: calc(100% - #{computer(140px)});
                margin-left: computer(120px);
              }
            }
          }

          &-error {
            height: computer(18px);
            line-height: computer(18px);
            color: $color_error;
            font-size: computer(14px);
            text-align: center;
          }

          &-button {
            margin-top: computer(20px);
            text-align: center;

            ::v-deep .el-button {
              width: computer(300px);

            }
          }

        }
      }
    }
  }
}

.mobile {
  .lw-schedule {
    
    &-center {
      &-top {
        padding-top: computer(20px);
        display: flex;
        align-items: flex-start;

        &-title {
          width: 80%;
          font-size: computer(16px);
          font-weight: bold;
          height: computer(40px);
          line-height: computer(40px);
        }

        &-operation {
          display: flex;
          justify-content: flex-end;
          width: 20%;

          ::v-deep {
            .class-id-code-join-entry {
              .dialog-button {
                min-width: computer(100px);
                font-size: computer(16px);
                padding: computer(6px) computer(20px);

                > span {
                  display: flex;
                  align-items: center;
                }

                .iconfont {
                  font-size: computer(24px);
                  margin-right: computer(5px);
                }

                .lwicon-hudongtiyansheji:before {
                  font-size: computer(26px);
                }
              }

              .el-button--primary {
                background: $color_main;
              }
            }

          }

        }
      }


      &-body {
        width: calc(100% - #{computer(10px)});
        padding: computer(20px) computer(5px) 0;

        &-title {
          margin-top: computer(20px);
          text-align: center;

          span {
            height: computer(30px);
            line-height: computer(30px);
            font-size: computer(24px);
            font-weight: 700;
          }
        }

        &-content {
          width: 100%;
          margin: computer(60px) computer(15px) 0;

          ::v-deep .el-form {
            width: 100%;
            margin: 0 auto;

            .el-form-item {
              margin: 0 computer(40px) computer(40px) computer(-40px);

              .el-form-item__label {
                width: computer(120px);
                padding: 0;
              }

              .el-form-item__content {
                width: calc(100% - #{computer(140px)});
                margin-left: computer(120px);
              }
            }
          }

          &-tips {
            height: computer(18px);
            line-height: computer(18px);
            font-size: computer(12px);
            color: $color_font-light;
          }

          &-error {
            width: calc(100% - #{computer(30px)});
            height: computer(18px);
            line-height: computer(18px);
            color: $color_error;
            font-size: computer(14px);
            text-align: center;
          }

          &-button {
            margin-top: computer(20px);
            text-align: center;

            ::v-deep .el-button {
              width: 50%;
            }
          }

        }
      }

    }
  }
}
</style>
